module.exports = __webpack_public_path__ + "static/media/mobile-notif.553cf1d2.png";